import { TagCloud as TagCloudComponent } from 'react-tagcloud';

export default function TagCloud({ data }) {
	return (
		<TagCloudComponent
			disableRandomColor={true}
			// colorOptions={{
			// 	count: 10,
			// 	luminosity: 'light',
			// 	hue: '#0099cc',
			// }}
			minSize={12}
			maxSize={30}
			tags={data}
		/>
	);
}
